/**
 * @file timeRangeMixin
 * @author fuqiang15
 */

import {get} from 'lodash';
import endOfDay from 'date-fns/end_of_day';

export default {
    computed: {
        timeRange: {
            get() {
                return this.store.filter.timeRange;
            },
            set(val) {
                if (get(val, '1')) {
                    val = [
                        val[0],
                        endOfDay(val[1])
                    ];
                }
                this.store.filter.timeRange = val;
            }
        }
    }
};
